import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';
import type { AddKeyRequest, EditKeyRequest, GetKeyRequest, GetKeyResponse, KeyMutationResponse } from './types';
import { prepareFormDataForKeyMutation } from './utils';

export * from './types';

const keyApi = createApi({
    reducerPath: 'lokaliseInternal_key',
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        getKey: builder.mutation<GetKeyResponse, GetKeyRequest>({
            query: ({ keyId }) => {
                const formData = new FormData();
                formData.append('action', 'get_key_data');
                formData.append('key_id', keyId);

                return {
                    url: `/ajax`,
                    method: 'POST',
                    body: formData,
                    headers: {
                        'x-auto-content-type': '1',
                    },
                };
            },
        }),
        editKey: builder.mutation<KeyMutationResponse, EditKeyRequest>({
            query: (data) => {
                const formData = prepareFormDataForKeyMutation(data);
                formData.append('existing_key_id', data.keyId);

                return {
                    url: `/project/${data.projectId}/edit_key`,
                    method: 'POST',
                    body: formData,
                    headers: {
                        'x-auto-content-type': '1',
                    },
                };
            },
        }),
        addKey: builder.mutation<KeyMutationResponse, AddKeyRequest>({
            query: (data) => ({
                url: `/project/${data.projectId}/add_key`,
                method: 'POST',
                body: prepareFormDataForKeyMutation(data),
                headers: {
                    'x-auto-content-type': '1',
                },
            }),
        }),
    }),
});

export default keyApi;

export const { useGetKeyMutation, useEditKeyMutation, useAddKeyMutation } = keyApi;
